import { Container, forwardRef } from '@chakra-ui/react'

export const AppContainer = forwardRef(
    /**
     * @typedef {Object} AppContainerProps
     * @property {boolean} [fluid]
     * @param {import('@chakra-ui/react').ContainerProps & AppContainerProps} props
     * @param {any} ref
     * @returns
     */
    ({ fluid = false, ...props }, ref) => {
        return (
            <Container
                ref={ref}
                maxW={fluid ? 'full' : 'container.xl'}
                // 余白いらないか要検討
                px={fluid ? 0 : 8}
                py={8}
                {...props}
            />
        )
    }
)
